import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faEdit, faPlus, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Link, Navigate } from "react-router-dom";
import { encryptAES } from '../../utils/Encryption';
import ValidationText from '../../utils/validation/ValidationText';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { APIURL, DownloadPolicy, PreviewPolicy } from '../../services/axiosServices/ApiEndPoints';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';

export default class Policy extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            policyList: [],
            downloadingIds: [],
            formList: [],
            globalFilter: '',
            dateRange: null,
            formDropdownType: 1,
            filterDetails: {
                start: 0,
                length: -1,
                search: '',
                sortField: '',
                sortOrder: 'asc',
                policy: ''
            },
            policyPage: {
                policy: '',
                formId: 0,
                policyId: 0,
                policyfile: null,
                isDisabled: false
                // policyPrevie: '',
            },
            validState: {
                isValid: true,
                error: {},
            },

            validationRules: {
                policy: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "policy name"),
                    },
                ],
                policyfile: [
                    {
                        type: "require",
                        message: CommonValidationMessages.UploadPdfRequired.replace("{0}", "policy file"),
                    },
                ],
                // formId: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.SelectRequired.replace("{0}", "Form"),
                //     }
                // ]
            }
        };
    }

    componentDidMount() {
        this.getPolicyList();
        this.getFormsList();
    }

    getFormsList = () => {
        let filterDetails = this.state.filterDetails;
        this.setState({ isLoading: true });

        let request = [this.state.formDropdownType, filterDetails.start, filterDetails.length, filterDetails.search, filterDetails.sortField, filterDetails.sortOrder];

        this.adminServices.getAllForms(request).then((response) => {
            if (response && response.data) {
                let res = response.data.map(form => ({
                    label: form.formname,
                    value: form.formid
                }));
                this.setState({ formList: res, isLoading: false });
            } else {
                this.setState({ isLoading: false });
            }
        });
    };

    getPolicyList = () => {
        let filterDetials = this.state.filterDetails;
        let request = [filterDetials.start, filterDetials.length, filterDetials.search, filterDetials.sortField, filterDetials.sortOrder];
        this.setState({ isLoading: true });
        this.adminServices.getPolicyList(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                this.setState({ policyList: res });
            }
            this.setState({ isLoading: false });
        });
    }

    actionBodyTemplate = (rowData) => {
        const isDownloading = this.state.downloadingIds.includes(rowData.policyid);
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="flex gap-2 justify-center items-center" style={{ marginRight: '20px' }}>
                    <Button
                        icon="pi pi-eye"
                        className="p-button-rounded p-button-text p-button-sm"
                        style={{ width: '2rem', height: '2rem', padding: 0 }}
                        onClick={() => this.handlePreviewPDF(rowData)}
                        tooltip="Preview PDF"
                        tooltipOptions={{ position: 'top' }}
                    />
                    {/* <Button
                        icon="pi pi-download"
                        className="p-button-rounded p-button-text p-button-sm"
                        style={{ width: '2rem', height: '2rem', padding: 0 }}
                        onClick={() => this.handleDownloadPDF(rowData)}
                        tooltip="Download PDF"
                        tooltipOptions={{ position: 'top' }}
                    /> */}
                    {
                        isDownloading ? (
                            <div style={{ width: '2rem' }}>
                                <ProgressSpinner style={{ width: '60%', height: '60%' }} strokeWidth="4" />
                            </div>
                        ) : (
                            <Button
                                icon="pi pi-download"
                                className="p-button-rounded p-button-text p-button-sm"
                                style={{ width: '2rem', height: '2rem', padding: 0 }}
                                onClick={() => this.handleDownloadPDF(rowData)}
                                tooltip="Download PDF"
                                tooltipOptions={{ position: 'top' }}
                            />
                        )
                    }
                </div>
                <div className="flex gap-2 justify-center" style={{ marginLeft: '20px' }}>
                    <Button
                        icon="pi pi-pencil"
                        className="p-button-rounded p-button-text p-button-sm"
                        style={{ width: '2rem', height: '2rem', padding: 0 }}
                        onClick={() => this.handleEdit(rowData)}
                        tooltip="Edit"
                        tooltipOptions={{ position: 'top' }}
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-text p-button-sm"
                        style={{ width: '2rem', height: '2rem', padding: 0 }}
                        onClick={() => this.handleDelete(rowData)}
                        tooltip="Delete"
                        tooltipOptions={{ position: 'top' }}
                    />
                </div>
            </div>
        );
    };

    handlePreviewPDF = (rowData) => {
        const filePath = rowData.policypath;
        const loginUser = getAuthProps();
        const token = loginUser.token;
        const secureUrl = `${APIURL}${PreviewPolicy}${filePath}`;

        fetch(secureUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(async response => {
            if (response.ok) {
                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
            } else {
                this.swalServices.Error('File not found');
            }
        }).catch(err => {
            console.error('Error opening file', err);
        });
    };

    handleDownloadPDF = async (rowData) => {
        const policyId = rowData.policyid;
        const loginUser = getAuthProps();
        const token = loginUser.token;
        const url = APIURL + DownloadPolicy + rowData.policypath;

        // Add to downloadingIds
        this.setState(prevState => ({
            downloadingIds: [...prevState.downloadingIds, policyId]
        }));

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;

                let filename = rowData.policypath.split('/').pop();
                link.download = filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(downloadUrl);
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Download failed', err);
        } finally {
            // Remove from downloadingIds
            this.setState(prevState => ({
                downloadingIds: prevState.downloadingIds.filter(id => id !== policyId)
            }));
        }

    };

    handleEdit = (rowData) => {
        if (rowData.policyid && rowData.policyid > 0) {
            let details = this.state.policyPage;
            details.policy = rowData.policyname;
            details.formId = rowData.formid;
            details.policyId = rowData.policyid;
            details.policyfile = rowData.filename;
            details.isDisabled = true;
            this.setState({ policyPage: details, policyId: rowData.policyId, formId: rowData.formId })
        }
        this.state.validState.error = {}
    };

    handleDelete = (rowData) => {
        this.state.validState.error = {}

        if (rowData.policyid && rowData.policyid > 0) {
            this.swalServices.Confirm(
                "",
                ``,
                CommonSuccessMessages.Yes_Text,
                CommonSuccessMessages.No_Text,
                `Are you sure you want to delete ?`
            ).then((response) => {
                if (response === true) {
                    this.adminServices.deletePolicy(rowData.policyid).then((response) => {
                        if (response.success === 1) {
                            let details = this.state.policyPage
                            details.policy = '';
                            details.formId = 0;
                            details.policyId = 0;
                            details.policyfile = null;

                            this.setState({ policyPage: details, formId: 0, policyId: 0 }, () => {
                                if (this.fileInputRef) {
                                    this.fileInputRef.value = null;
                                }
                                this.getPolicyList();
                                this.swalServices.Success(response.msg)
                            });
                        } else {
                            this.swalServices.Error(response.msg)
                        }
                    });
                    this.state.policyPage.isDisabled = false;
                }
            })
        }
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.policyPage;
        details[name] = value;
        this.setState({ policyPage: details });
    };

    isValidAllFields = () => {
        let state = {
            policy: this.state.policyPage.policy,
            policyfile: this.state.policyPage.policyfile,
            formId: this.state.policyPage.formId,
            policyId: this.state.policyPage.policyId
        }
        const newValidState = isValidForm(
            state,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    createPolicy = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.policyPage;

            const formData = new FormData();
            formData.append('policyName', details.policy);
            formData.append('policy', details.policyfile);
            formData.append('formId', details.formId);

            this.adminServices.createPolicy(formData).then((response) => {
                if (response.success === 1) {
                    let details = this.state.policyPage;
                    details.policy = '';
                    details.formId = 0;
                    details.policyfile = null;
                    this.setState({ policyPage: details, formId: 0 }, () => {
                        if (this.fileInputRef) {
                            this.fileInputRef.value = null;
                        }
                        this.swalServices.Success(response.msg);
                        this.getPolicyList();
                    });
                } else {
                    this.swalServices.Error(response.msg);
                }
                this.setState({ isLoading: false });
            });
            this.state.policyPage.isDisabled = false;
        }
    }

    updatePolicy = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.policyPage;
            const formData = new FormData();
            formData.append('policyName', details.policy);
            formData.append('policy', details.policyfile);
            formData.append('formId', details.formId);

            this.adminServices.updatePolicy(formData, details.policyId).then((response) => {
                if (response.success === 1) {
                    let details = this.state.policyPage
                    details.policy = '';
                    details.formId = 0;
                    details.policyfile = null;
                    this.setState({ policyPage: details, formId: 0 }, () => {
                        if (this.fileInputRef) {
                            this.fileInputRef.value = null;
                        }
                        this.swalServices.Success(response.msg)
                        this.getPolicyList()
                    })
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
            this.state.policyPage.isDisabled = false;
        }
    }

    filterByDateRange = (createddate) => {
        const { dateRange } = this.state;

        if (!dateRange || !dateRange[0] || !dateRange[1]) return true;

        const created = new Date(createddate);
        const start = new Date(dateRange[0]);
        const end = new Date(dateRange[1]);

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        return created >= start && created <= end;
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const details = { ...this.state.policyPage };
            details.policyfile = file;
            this.setState({ policyPage: details });
        }
    };
    handleSelectChange = (selectedOptions, name) => {
        let policyPage = this.state.policyPage
        policyPage[name] = selectedOptions.value
        this.setState({ policyPage: policyPage });
    };

    handleWebVisibilityChange = (rowData, isChecked) => {
        const updatedList = this.state.policyList.map((item) => {
            if (item.policyid === rowData.policyid) {
                return { ...item, iswebvisible: isChecked ? 1 : 0 };
            }
            return item;
        });

        this.setState({ policyList: updatedList });
        let request = {
            policyId: rowData.policyid,
            isWebVisible: isChecked ? 1 : 0
        }
        this.adminServices.updatePolicyWebVisibility(request).then((response) => {
        });
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const filteredData = this.state.policyList.filter((row) =>
            this.filterByDateRange(row.createddate)
        );

        return (
            <div className='policy-lists'
                style={{ height: "calc((100dvh / 0.85) - 28.8px)" }}
            >
                <div className='policy-lists-inner h-full p-[30px] overflow-y-auto'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Form Policy</h1>
                    </div>
                    <div className='policy-add p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        {this.state.formId > 0 ?
                            <h2
                                className='text-[16px] font-semibold mt-0'
                            >
                                Edit policy
                            </h2>
                            :
                            <h2
                                className='text-[16px] font-semibold mt-0'>
                                Add New Policy
                            </h2>
                        }
                        <div className='policy-add-inner'>
                            <div className='input-grp !mb-0 col-span-2'>
                                <label>Policy Name:</label>
                                <input
                                    type='text'
                                    placeholder='Enter Policy'
                                    id='policy'
                                    name='policy'
                                    className={`${this.state.validState?.error?.policy ? "error" : ""}`}
                                    value={this.state.policyPage.policy}
                                    onChange={(event) => this.handleChange(event, "policy")}
                                />
                                <ValidationText error={this.state.validState.error.policy} />
                            </div>
                            <div className='input-grp pt-5 !mb-0 col-span-2'>
                                <label>Upload Policy</label>
                                <input
                                    type='file'
                                    accept='application/pdf'
                                    onChange={this.handleFileChange}
                                    ref={(ref) => (this.fileInputRef = ref)}
                                    className={`${this.state.validState?.error?.policyfile ? "error" : ""}`}
                                />
                                {/* 👇 Show the filename if it exists */}
                                {this.state.policyPage.policyfile && typeof this.state.policyPage.policyfile === 'string' && (
                                    <p className="filename-preview" style={{ fontSize: "small", color: 'green' }}>Current file: {this.state.policyPage.policyfile}</p>
                                )}
                                <ValidationText error={this.state.validState.error.policyfile} />
                                {/* {this.state.blogForm.bannerPreview && (
                                    <img
                                        src={this.state.blogForm.bannerPreview}
                                        alt='Preview'
                                        className={`mt-4 w-full rounded-[10px] object-cover `}
                                        style={{ maxHeight: "300px" }}
                                    />
                                )} */}
                            </div>
                            <div className='input-grp pt-5 !mb-0 col-span-2'>
                                <label>Link Form</label>
                                <MultiSelectDropdown
                                    options={this.state.formList}
                                    onChange={(selected) => this.handleSelectChange(selected, 'formId')}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    // className={`${this.state.validState?.error?.formId ? "error" : ""}`}
                                    value={this.state.formList.filter(item => item.value === this.state.policyPage.formId)}
                                // isDisabled={this.state.policyPage.isDisabled}
                                />
                                {/* <ValidationText error={this.state.validState.error.formId} /> */}

                            </div>
                            {this.state.policyPage.policyId > 0 ?
                                <button
                                    onClick={() => this.updatePolicy()}
                                    className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0 mt-5'>
                                    <FontAwesomeIcon className='w-5 h-5' icon={faEdit} />
                                    Update policy
                                </button>
                                :
                                <button
                                    onClick={() => this.createPolicy()}
                                    className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0 mt-5'>
                                    <FontAwesomeIcon className='w-5 h-5' icon={faAdd} />
                                    Save policy
                                </button>
                            }
                        </div>
                    </div>
                    <div className='policy-table p-5 bg-white rounded-[16px] mt-[20px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.globalFilter}
                                    onChange={(e) => this.setState({ globalFilter: e.target.value })}
                                    placeholder="Search across all columns..."
                                />
                            </div>
                            {/* <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.setState({ dateRange: e.value })}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="dd-mm-yy"
                                    readOnlyInput
                                    numberOfMonths={2}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.setState({ globalFilter: '', dateRange: null })}
                            /> */}
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[20px]'>
                            <div style={{ overflowX: 'auto' }}>
                                <div style={{ minWidth: '1600px' }}> {/* Add large minWidth here for scrolling */}
                                    <DataTable value={filteredData}
                                        paginator rows={50}
                                        responsiveLayout="scroll"
                                        scrollable
                                        scrollHeight="calc((100dvh / 0.85) - 560px)"
                                        className="min-w-full"
                                        globalFilter={this.state.globalFilter}
                                        filterFunction={this.filterByDateRange}
                                        filterElement={this.dateRangeFilterTemplate}
                                        emptyMessage="No data found"
                                        loading={this.state.isLoading}
                                        loadingIcon={
                                            <div className="flex justify-center items-center w-full py-4">
                                                <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                            </div>
                                        }
                                    >
                                        <Column
                                            field="formid"
                                            header="SrNo"
                                            style={{ width: '50px' }}
                                            body={(rowData, options) => options.rowIndex + 1}
                                            filterPlaceholder="Search by ID"
                                            headerClassName="bg-blue-50 text-blue-800 font-medium" ></Column>
                                        <Column
                                            field="iswebvisible"
                                            header="Web Visibility"
                                            style={{ width: '50px' }}
                                            body={(rowData) => (
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={rowData.iswebvisible === 1}
                                                        onChange={(e) => this.handleWebVisibilityChange(rowData, e.target.checked)}
                                                    />
                                                </div>
                                            )}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                        />
                                        <Column
                                            field="policyname"
                                            header="Policy Name"
                                            style={{ width: '500px' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="formname"
                                            header="Associated Form"
                                            style={{ width: '500px' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="filename"
                                            header="File"
                                            style={{ width: '300px' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="createdby"
                                            header="Created By"
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="createddate"
                                            header="Created Date"
                                            style={{ width: '200px' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="modifiedby"
                                            header="Modified By"
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="modifieddate"
                                            header="Modified Date"
                                            style={{ width: '200px' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            field="ip"
                                            header="IP"
                                            style={{ width: '100px' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                            sortable filterPlaceholder="Search by ID"
                                        />
                                        <Column
                                            header="Actions"
                                            body={this.actionBodyTemplate}
                                            style={{ textAlign: 'center', width: '10rem' }}
                                            headerClassName="bg-blue-50 text-blue-800 font-medium"
                                        />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
